module.exports = __webpack_public_path__ + "img/pic_5.a9bfe77a.jpg";